<template>
  <b-container>
    <h1 class="text-center">Contact Us</h1>
    <hr>
    <b-row>
      <b-col lg="6" md="12">
        <p><strong>Thank you for your interest. For questions or comments please use the information below. We look forward to hearing from you soon.</strong></p>
        <h3>Phone:</h3>
        <b-link href="tel:8047483099">(804) 748-3099</b-link>
        <br>
        <br>
        <h3>Fax:</h3>
        <p>(804) 796-5897</p>
        <h3>Email:</h3>
        <b-link href="mailto:moldmanusa@gmail.com">moldmanusa@gmail.com</b-link>
        <br>
        <br>
        <p>Proudly Serving Richmond Tri-City, Henrico, Hanover, Chesterfield, &amp; Surrounding Counties</p>
      </b-col>
      <b-col lg="6" md="12">
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdjJBshyIBnz1CNkhwiwYhu_ErKjrwOqq42QHm5TNzGrS3NoQ/viewform?embedded=true" width="100%" height="1171" frameborder="0" marginheight="0" marginwidth="0">Loading...</iframe>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {

}
</script>

<style>

</style>
